/**
 * Obtiene el valor del dólar desde APIs públicas y lo redondea hacia arriba en múltiplos de 5
 * @returns {Promise<number|null>} El valor del dólar redondeado o null si hay error
 */
export const obtenerDolarAutomatico = async () => {
  try {
    // API 1: DolarAPI (más confiable y sin CORS)
    try {
      const response1 = await fetch("https://dolarapi.com/v1/dolares", {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
        }
      });
      
      if (response1.ok) {
        const data = await response1.json();
        
        // Buscar específicamente el valor de Santander
        for (const banco of data) {
          if (banco.nombre && banco.nombre.toLowerCase().includes('santander')) {
            const valorRaw = banco.venta;
            if (valorRaw && valorRaw !== 'No disponible') {
              const valorNum = parseFloat(valorRaw);
              // Redondear hacia arriba en múltiplos de 5
              const valorRedondeado = Math.ceil(valorNum / 5) * 5;
              return Math.floor(valorRedondeado); // Sin decimales
            }
          }
        }
        
        // Si no encuentra Santander, usar el primer banco disponible
        if (data && data.length > 0) {
          const valorRaw = data[0].venta;
          if (valorRaw && valorRaw !== 'No disponible') {
            const valorNum = parseFloat(valorRaw);
            const valorRedondeado = Math.ceil(valorNum / 5) * 5;
            return Math.floor(valorRedondeado);
          }
        }
      }
    } catch (error) {
      console.log('API 1 falló, intentando API 2...');
    }
    
    // API 2: ExchangeRate-API (alternativa confiable)
    try {
      const response2 = await fetch("https://api.exchangerate-api.com/v4/latest/USD", {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
        }
      });
      
      if (response2.ok) {
        const data2 = await response2.json();
        if (data2.rates && data2.rates.ARS) {
          const valorNum = data2.rates.ARS;
          const valorRedondeado = Math.ceil(valorNum / 5) * 5;
          return Math.floor(valorRedondeado);
        }
      }
    } catch (error) {
      console.log('API 2 falló, intentando API 3...');
    }
    
    // API 3: Fixer.io (tercera alternativa)
    try {
      const response3 = await fetch("https://api.fixer.io/latest?base=USD&symbols=ARS", {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
        }
      });
      
      if (response3.ok) {
        const data3 = await response3.json();
        if (data3.rates && data3.rates.ARS) {
          const valorNum = data3.rates.ARS;
          const valorRedondeado = Math.ceil(valorNum / 5) * 5;
          return Math.floor(valorRedondeado);
        }
      }
    } catch (error) {
      console.log('API 3 falló...');
    }
    
    // API 4: Open Exchange Rates (cuarta alternativa)
    try {
      const response4 = await fetch("https://open.er-api.com/v6/latest/USD", {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
        }
      });
      
      if (response4.ok) {
        const data4 = await response4.json();
        if (data4.rates && data4.rates.ARS) {
          const valorNum = data4.rates.ARS;
          const valorRedondeado = Math.ceil(valorNum / 5) * 5;
          return Math.floor(valorRedondeado);
        }
      }
    } catch (error) {
      console.log('API 4 falló...');
    }
    
    return null;
    
  } catch (error) {
    console.error('Error obteniendo dólar automático:', error);
    return null;
  }
};

/**
 * Formatea el valor del dólar para mostrar
 * @param {number} valor - El valor del dólar
 * @returns {string} El valor formateado
 */
export const formatearDolar = (valor) => {
  if (!valor) return 'No disponible';
  return `$${valor.toLocaleString('es-AR')}`;
}; 